<template>
	<div style="height: 100%;">
		<el-container>
			<el-header>
				<div style="display: flex;justify-content: start;align-items: center;height:100%;">
					<el-avatar shape="circle" src=""><img width="100%" height="100%" src="../assets/logo.jpg" /></el-avatar>
					<div style="margin-left: 8px;color:#FFFFFF;font-size: 1.5rem;letter-spacing: 3px;">喀什美之旅租车平台</div>
				</div>
			</el-header>
			<el-container>
				<el-aside width="200px" style="height: calc(100vh - 60px);" class="asideClass">
					<el-menu default-active="1" class="el-menu-vertical-demo" :router="true" style="width: 200px;" active-text-color="rgb(56, 116, 246)">
						<el-menu-item index="1" :route="{ path: 'home' }">
							<i class="el-icon-menu"></i>
							<span slot="title">首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页</span>
						</el-menu-item>
						<el-submenu index="2">
							<template slot="title">
								<i class="el-icon-s-home"></i>
								<span slot="title">门店管理</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="2-1" :route="{path:'storeList'}">已认证门店</el-menu-item>
								<el-menu-item index="2-2" :route="{path:'storeListUnAuth'}">待认证门店</el-menu-item>
								<el-menu-item index="2-3" :route="{path:'addStore'}">添加门店</el-menu-item>
								<el-menu-item index="2-4" :route="{path:'employeManage'}">账号管理</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="3">
							<template slot="title">
								<i class="el-icon-s-promotion"></i>
								<span slot="title">扣款管理</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" :route="{path:'payFinish'}">扣款申请</el-menu-item>
								<el-menu-item index="3-2" :route="{path:'payList'}">扣款记录</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="4">
							<template slot="title">
								<i class="el-icon-s-flag"></i>
								<span slot="title">免押管理</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="4-1" :route="{path:'freezeing'}">进行中授权</el-menu-item>
								<el-menu-item index="3-2" :route="{path:'freezeList',query:{freeze_state:[0,1,2,3]}}">授权记录</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="5">
							<template slot="title">
								<i class="el-icon-s-promotion"></i>
								<span slot="title">提现管理</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="5-1" :route="{path:'tixianshenqing'}">提现申请</el-menu-item>
								<el-menu-item index="5-2" :route="{path:'tixianjilu'}">提现记录</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="6">
							<template slot="title">
								<i class="el-icon-s-promotion"></i>
								<span slot="title">帮助反馈</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="6-1" :route="{path:'fankuijianyi'}">反馈建议</el-menu-item>
								<el-menu-item index="6-2" :route="{path:'changjianwenti'}">常见问题</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="7">
							<template slot="title">
								<i class="el-icon-s-tools"></i>
								<span slot="title">系统设置</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="7-1" :route="{path:'zhanghaoguanli'}">账号管理</el-menu-item>
								<el-menu-item index="7-2" :route="{path:'tianjiazhanghao'}">添加账号</el-menu-item>
								<!-- <el-menu-item index="7-2" :route="{path:'juesequanxian'}">角色权限</el-menu-item> -->
								<!-- <el-menu-item index="7-3">权限管理</el-menu-item> -->
								<el-menu-item index="7-4" :route="{path:'admin_info'}">个人信息</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</el-menu>
				</el-aside>
				<el-container >
					<el-main class="mainClass">
						<router-view></router-view>
					</el-main>
				</el-container>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: {},

			};
		},
		methods: {

		},
		mounted() {
			// var that=this;

			this.$router.push('home');
		}
	};
</script>

<style>
	.asideClass::-webkit-scrollbar {
		width: 5px;
		background-color: white;
	}

	.asideClass::-webkit-scrollbar-thumb {
		width: 5px;
		background-color: #DCDFE6;
		border-radius: 10px;
	}

	.asideClass {
		overflow-x: hidden;
	}

	.mainClass::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.mainClass::-webkit-scrollbar-thumb {
		width: 8px;
		height: 8px;
		background-color: #909399;
		border-radius: 10px;
	}

	.el-header,
	.el-footer {
		color: #333;
		line-height: 60px;
	}

	.el-header {
		background-color: rgb(56, 116, 246);
		color: #fff;
	}

	.el-aside {
		background-color: white;
		text-align: left;
		/* height: calc(100vh - 100px); */
	}

	.el-main {
		background-color: #EFF1F4;
		color: #333;
		height: calc(100vh - 80px);
	}

	.el-container {
		height: 100%;
	}

	.el-container:nth-child(5) .el-aside,
	.el-container:nth-child(6) .el-aside {}

	.el-container:nth-child(7) .el-aside {}
</style>



// WEBPACK FOOTER //
// src/components/index.vue